import { GeotabError } from "@fairfleet/geotab";
import { TFunction } from "i18next";
import { I18nError } from "./I18nError";
import { NoDriverAccessError } from "./NoDriverAccessError";
import { UnexpectedError } from "./UnexpectedError";

/**
 * Attempts to demystify an error into something the user can understand.
 *
 * @param t - The translation function.
 * @param error - The error to demystify.
 */
export function demystifyError(t: TFunction, error: unknown) {
  return getI18Error(error).i18nMessage(t);
}

function getI18Error(err: unknown) {
  if (err instanceof I18nError) {
    return err;
  }

  if (err instanceof GeotabError) {
    if (err.message.match(/User does not have access to this driver/i)) {
      return new NoDriverAccessError();
    }
  }

  return new UnexpectedError();
}
